export default __webpack_public_path__ + "static/media/en.a4629d2f.svg";